module.exports = __webpack_public_path__ + "img/logo.d66305a2.webp";